var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 72,
    width: 72,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#030104",
    d: "m46.271936,23.677126c-6.254,-6.226 -16.37,-6.201 -22.594,0.051c-6.227,6.254 -6.204,16.37 0.049,22.594c6.256,6.226 16.374,6.203 22.597,-0.051c6.224,-6.254 6.203,-16.371 -0.052,-22.594z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#030104",
    d: "m32.309936,42.918126l-1.768,5.207c2.567,0.829 5.331,0.886 7.926,0.17l-0.665,-5.416c-1.771,0.63 -3.714,0.643 -5.493,0.039zm-5.168,-10.774l-5.645,-0.859c-0.741,2.666 -0.666,5.514 0.225,8.143l5.491,-1.375c-0.739,-1.893 -0.765,-4.002 -0.071,-5.909zm20.643,-1.789l-4.965,1.675c0.798,2.106 0.716,4.468 -0.247,6.522l5.351,0.672c0.925,-2.883 0.878,-6.009 -0.139,-8.869zm-17.369,-8.45l1.018,5.528c2.027,-0.954 4.356,-1.05 6.442,-0.288l1.583,-5.137c-2.914,-1.046 -6.109,-1.08 -9.043,-0.103z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_4",
    fill: "#030104",
    r: 7.117,
    cy: 34.999126,
    cx: 35.000936
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.e29d0ea022ff1434ce1e6f1250d781c9.svg";
export { ForwardRef as ReactComponent };